<template>
  <div v-if="works.length > 0" v-html="works[0].body"></div>
</template>


<script setup>

import { usePostServiceStore } from '@/stores/postService'

const postStore = usePostServiceStore();
const { fetchHomeWorkData } = usePostServiceStore();

await fetchHomeWorkData();

const { works } = storeToRefs(postStore);

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";


</style>
